document.addEventListener('DOMContentLoaded', () => {
  function updateCartBubble(count) {
    const bubble = document.querySelector('#cart-icon-bubble');
    if (bubble) {
      const visible = bubble.querySelector('[aria-hidden="true"]');
      if (visible) {
        const displayCount = count ?? 0;
        visible.textContent = `(${displayCount})`;
      }
      const sr = bubble.querySelector('.visually-hidden:last-of-type');
      if (sr) {
        const displayCount = count ?? 0;
        sr.textContent = `${displayCount} item${displayCount === 1 ? '' : 's'}`;
      }
    }
  }

  document.body.addEventListener('cart:updated', (e) => {
    if (e.detail?.cart) {
      const count = typeof e.detail.cart.itemCount === 'function' ? e.detail.cart.itemCount() : e.detail.cart.item_count;
      updateCartBubble(count);
    }
  });
});
